module.exports = __webpack_public_path__ + "271f2b53994cc2c2639f162f976f92d6.png";


//////////////////
// WEBPACK FOOTER
// ./statics/imgs/home/shopping-btn-bg.png
// module id = 186
// module chunks = 0